goog.provide("shadow.js.shim.module$src$svg$files_folders$file_new_svg");
goog.provide("module$shadow_js_shim_module$src$svg$files_folders$file_new_svg");
shadow.js.shim.module$src$svg$files_folders$file_new_svg = shadow.js.nativeProvides["src/svg/files_folders/file-new.svg"] = shadow$bridge("src/svg/files_folders/file-new.svg");
module$shadow_js_shim_module$src$svg$files_folders$file_new_svg.default = shadow.js.shim.module$src$svg$files_folders$file_new_svg;
